import { useCallback, useState } from "react";

import {
  isCoolingDown,
  readDismissedAt,
  writeDismissedAt,
} from "./install-banner-dismissal";

/**
 * Whether a recent dismissal still hides the install banner, and the action
 * that records one. Evaluated when the banner mounts, then flipped by
 * `dismiss()`; a 14-day cool-down does not need to tick while the app is open.
 */
export function useInstallBannerDismissal() {
  const [coolingDown, setCoolingDown] = useState(() =>
    isCoolingDown(readDismissedAt(), Date.now()),
  );

  const dismiss = useCallback(() => {
    writeDismissedAt(Date.now());
    setCoolingDown(true);
  }, []);

  return { coolingDown, dismiss };
}
